import { resolveCustomerName } from 'helpers/customerNameResolver';
import Customer from 'models/CustomerModel';
import React, { useEffect, useState } from 'react';

interface Props {
    customerId?: string;
    customer?: Customer;
}

const CustomerFullName: React.FC<Props> = ({ customerId, customer }: Props) => {
    const [customerFullName, setCustomerFullName] = useState('');

    useEffect(() => {
        if (customer) {
            setCustomerFullName(customer.firstName + ' ' + customer.lastName);
        } else if (!!customerId) {
            resolveCustomerName(customerId)
                .then((createdByUserFullName) => setCustomerFullName(createdByUserFullName))
                .catch((_) => _);
        }
    }, [customerId, customer]);

    return <>{customerFullName}</>;
};

export default CustomerFullName;
